import { PROYECT, api_put, api_get, api_post } from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"
import { inventoryTypes } from "redux/reducers/inventories/types"

export const {
  GET_SHIPMENT_INVENTORY,
  GET_ALL_BY_SHIPMENT_NUMBER,
  DELETE_SHIPMENT,
  GET_CARRIERS_INVENTORY,
  GET_CARRIER_SHIPMENT_INVENTORY,
  GET_ALL_SHIPPER_TRUCKS,
  GET_NATIONAL_NOTES_AVAILABLE,
  TOGGLE_NOTES_NATIONAL,
  SAVE_SHIPMENT,
} = inventoryTypes


const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/shipments_enersi`
const carrierUrl = `${process.env.REACT_APP_URL}${PROYECT}/carriers`
const shipperTruckUrl = `${process.env.REACT_APP_URL}${PROYECT}/shipper-trucks`
const nationalNotesUrl = `${process.env.REACT_APP_URL}${PROYECT}/national-notes`


export const getShipmentsInventory = (id) => {
  const url = `${mainUrl}/${id}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_SHIPMENT_INVENTORY,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingInventory'))
  }
}

export const getAllByShipmentNumber = (shipmentNumber) => {
  const url = `${mainUrl}/shipment_number/?shipmentNumber=${shipmentNumber}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_ALL_BY_SHIPMENT_NUMBER,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingInventory'))
  }
}

export const deleteShipment = (shipmentId) => async (dispatch) => {
  const url = `${mainUrl}/${shipmentId}/reset`;
  dispatch(startRequestComp('deleteShipment'));
  try {
    await api_put(url);
    return dispatch(deleteLocalShipment(shipmentId));
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp('deleteShipment'));
  }
};

// Elimina un embarque que aún no se ha guardado en el backend,
// removiéndolo únicamente del estado local.
export const deleteLocalShipment = (shipmentId) => (dispatch) => {
  dispatch({ type: DELETE_SHIPMENT, payload: shipmentId });
  dispatch(setSnackbar("Embarque eliminado con éxito.", "success"));
  return true;
};

export const getCarriers = () => {
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_get(carrierUrl).then(resp => {
      dispatch({
        type: GET_CARRIER_SHIPMENT_INVENTORY,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingInventory'))
  }
}

export const getAllShipperTruck = () => {
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_get(shipperTruckUrl).then(resp => {
      dispatch({
        type: GET_ALL_SHIPPER_TRUCKS,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingInventory'))
  }
}

export const getNationalNotes = (idStation) => {
  const url = `${nationalNotesUrl}/available/${idStation}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_NATIONAL_NOTES_AVAILABLE,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingInventory'))
  }
}

export const saveNationalNotes = (form, idStation, action=null) => {
  const url = `${nationalNotesUrl}/discount-shipments`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_post(url, form ).then(_res => {
      dispatch(setSnackbar("notas guardadas", "success"))
      action && action()
      dispatch(getNationalNotes(idStation))
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingInventory'))
  }
}

export const toggleNotes = (shipmentId, id) => {
  return {
    type: TOGGLE_NOTES_NATIONAL,
    payload: { shipmentId, id }
  }
}

export const saveShipment = ({ shipmentId, form }) => async (dispatch) => {
  const url = `${mainUrl}/${shipmentId}/V2`;
  const { carrier, shipperTruck, ...rest } = form;
  dispatch(startRequestComp('saveShipment'));
  try {
    await api_put(url, rest);
    dispatch({ type: SAVE_SHIPMENT, payload: {
      shipmentId,
      carrier,
      shipperTruck,
      ...rest,
    }});
    dispatch(setSnackbar("Embarque guardado con éxito.", "success"));
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp('saveShipment'));
  }
};